// src/App.jsx
import React, { Suspense, lazy, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useStore } from './store/useStore';
import { PageTitleProvider } from './context/PageTitleContext';
import LoadingScreen from './components/common/LoadingScreen';
import ErrorBoundary from './components/common/ErrorBoundary';
import PrivateRoute from './components/auth/PrivateRoute';

const Login = lazy(() => import('./pages/auth/Login'));
const Dashboard = lazy(() => import('./pages/dashboard/Dashboard'));
const MapTracking = lazy(() => import('./pages/map/MapTracking'));
const TripPlayback = lazy(() => import('./pages/playback/TripPlayback'));
const FuelMonitor = lazy(() => import('./pages/fuel/FuelMonitor'));
const VesselManagement = lazy(() => import('./pages/vessels/VesselManagement'));
const VesselRegistration = lazy(() => import('./pages/vessels/VesselRegistration'));
const VesselEdit = lazy(() => import('./pages/vessels/VesselEdit'));  // <-- TAMBAHKAN
const CompanyManagement = lazy(() => import('./pages/companies/CompanyManagement'));
const UserManagement = lazy(() => import('./pages/users/UserManagement'));
const Reports = lazy(() => import('./pages/reports/Reports'));
const Settings = lazy(() => import('./pages/settings/Settings'));
const NotFound = lazy(() => import('./pages/notfound/NotFound'));
const SensorMonitor = lazy(() => import('./pages/sensors/SensorMonitor'));

function App() {
  const { initializeApp, isInitialized, darkMode } = useStore();

  useEffect(() => { initializeApp(); }, [initializeApp]);
  useEffect(() => { if (darkMode) document.documentElement.classList.add('dark'); else document.documentElement.classList.remove('dark'); }, [darkMode]);

  if (!isInitialized) return <LoadingScreen />;

  return (
    <ErrorBoundary>
      <PageTitleProvider>
        <Suspense fallback={<LoadingScreen />}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<PrivateRoute />}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/map" element={<MapTracking />} />
              <Route path="/sensors" element={<SensorMonitor />} />
              <Route path="/playback" element={<TripPlayback />} />
              <Route path="/playback/:tripId" element={<TripPlayback />} />
              <Route path="/fuel" element={<FuelMonitor />} />
              <Route path="/vessels" element={<VesselManagement />} />
              <Route path="/vessels/register" element={<VesselRegistration />} />
              <Route path="/vessels/:id/edit" element={<VesselEdit />} />  {/* <-- TAMBAHKAN */}
              <Route path="/companies" element={<CompanyManagement />} />
              <Route path="/users" element={<UserManagement />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </PageTitleProvider>
    </ErrorBoundary>
  );
}

export default App;